<section class="mb-4 flex items-center justify-between">
  <aux-card
    topText="Total (USD)"
    [middleText]="totalCost$ | async | money"
    className="min-w-[230px]"
  />
  <div class="flex items-center space-x-4">
    @if (!!(lastSourceRefreshDate$ | async)) {
      <p>Updated: {{ lastSourceRefreshDate$ | async | date: 'MMMM d, y, h:mm a' }}</p>
    }
    @if (!!(lastSourceRefreshDate$ | async)) {
      <div class="h-7 w-px bg-aux-gray-dark"></div>
    }
    <aux-checkbox
      class="text-sm"
      [checked]="(isContractSelected$ | async)!"
      [disabled]="!!(editMode$ | async)!"
      (customChange)="toggleContractCurrency($event)"
    >
      Show Contracted Currency
    </aux-checkbox>
    <aux-exchange-link />
    <div class="h-7 w-px bg-aux-gray-dark"></div>
    <aux-export-excel-button
      [clickFN]="onExportInvestigatorTransactions.bind(this)"
      [loading]="isBtnLoading('export') | async"
      [spinnerSize]="7"
      pendoTag="investigator-transactions-excel-export-button"
    />
  </div>
</section>
